<template>
  <div class="ui stackable grid">
    <div id="loader" class="ui active dimmer" v-if="loading">
      <div class="ui text loader">Loading</div>
    </div>
      <div class="twelve wide column">
      <div class="ui form">
        <div class="field">
          <div v-if="!isEditing"><h1>{{item.name}}</h1></div>
          <div v-if="isEditing" class="ui input"><input type="text" v-model="item.name" placeholder="name the thing" /></div>
        </div>
        <div class="field">
          <div v-if="!isEditing"><a class="ui card_price tag green label">${{item.value}}</a></div>
          <div v-if="isEditing" class="ui input"><input type="text" v-model="item.value" placeholder="how much is it worth?" /></div>
        </div>
        <div class="field">
          <div v-if="!isEditing">{{item.description}}</div>
          <div v-if="isEditing"><textarea rows="2" v-model="item.description" placeholder="enter a short description here"></textarea></div>
        </div>
        <div class="field">
          <div class="ui labels">
            <a v-for="(tag, index) in tags" :key="index" v-bind:class="{ 'ui': true, 'label': true, 'grey': !tag.enabled, 'green': tag.enabled }" @click="setTag(tag)">{{tag.name}}</a>
          </div>
        </div>
        <div class="ui buttons">
          <router-link :to="{ name: 'CaptureItem', 'params': {id: item.id}}" class="ui button">
            <i class="icon add"></i>
            Add Photos
          </router-link>
          <button class="ui button" @click="save" v-if="isEditing">
            <i class="icon save"></i>
            Save
          </button>
          <button class="ui button" @click="cancel" v-if="isEditing">
            <i class="icon cancel"></i>
            Cancel
          </button>
          <button class="ui button" @click="edit" v-if="!isEditing">
            <i class="icon edit"></i>
            Edit
          </button>
          <!-- <button class="ui button">Three</button> -->
        </div>

      </div>

      <div class="ui divider"></div>

      <h2>
        Photos
      </h2>
      <div v-if="!photosLoaded">
        <div class="ui three column stackable grid">
          <div class="column">
            <div class="ui raised segment">
              <div class="ui placeholder">
                <div class="image header">
                  <div class="line"></div>
                  <div class="line"></div>
                </div>
                <div class="paragraph">
                  <div class="medium line"></div>
                  <div class="short line"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="column">
            <div class="ui raised segment">
              <div class="ui placeholder">
                <div class="image header">
                  <div class="line"></div>
                  <div class="line"></div>
                </div>
                <div class="paragraph">
                  <div class="medium line"></div>
                  <div class="short line"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="column">
            <div class="ui raised segment">
              <div class="ui placeholder">
                <div class="image header">
                  <div class="line"></div>
                  <div class="line"></div>
                </div>
                <div class="paragraph">
                  <div class="medium line"></div>
                  <div class="short line"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="photosLoaded" class="ui link three cards">
        <!-- <div class="card">
            <div class="image">
              <img :src="item.data">
            </div>
            <div class="content">
              <div class="header">Featured</div>
            </div>
            <div class="ui bottom attached button" @click="scan(item)">
              <i class="eye icon"></i>
              Scan
            </div>
        </div> -->
        <div class="card" v-for="(photo, index) in photos" :key="index">
            <div class="image">
              <img v-if="photo.processed" :src="photo.data" @error="setAltImg(photo)">
              <img v-if="!photo.processed" :src="photo.fullSizeUrl" @error="setAltImg(photo)">
            </div>
            <div class="content">
              <span class="ui label" v-for="(object, objindex) in photo.objects" :key="objindex">
                {{object.name}}
              </span>
              <a target="_blank" v-if="photo.processed" :href="photo.fullSizeUrl">Processed Url</a><br />      
              <a target="_blank" v-if="!photo.processed" :href="photo.data">Original url</a><br /> 
              <span v-if="photo.scanned && photo.objects.length == 0">No data found in scan</span>
            </div>
            <div class="ui bottom attached button" @click="setFeaturedImage(photo)" v-if="photo.data != item.data">
              <i class="gift icon"></i>
              Make Featured
            </div>
            <div :class="{'ui bottom attached button': true, 'disabled': photo.scanning, 'loading': photo.scanning}" @click="scan(photo)" v-if="photo.objects.length == 0 && !photo.scanned">
              <i class="eye icon"></i>
              Scan
            </div>
            <div class="ui bottom attached button" @click="archivePhoto(photo)" v-if="photo.data != item.data">
              <i class="box icon"></i>
              Archive
            </div>
        </div>
      </div>
    </div>
    <div class="ui mini modal">
      <i class="close icon"></i>
      <div class="header">
          {{modalHeader}}
      </div>
      <div class="content">
        <div class="ui form">
          <div class="field twelve wide">
            {{modalMessage}}
          </div>
          <div class="field">
            <label></label><br />
            <div class="ui fluid input">
              <div class="ui primary button" @click="doModalAction">
                Confirm
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { mapGetters } from 'vuex'
import firebase from 'firebase'
export default {
  name: 'Item',
  components: {
  },
    data() {
        return {
          isEditing: false,
          ffunctions: [],
          photosLoaded: false,
          loading: false,
          modalHeader: "",
          modalMessage: "",
          modalAction: async function() {}
        };
    },
    async mounted() {
      if (this.$route.params.id) {
        // this.item = this.$store.getters['ItemModule/getById'](this.$route.params.id)

        const where = [['created_by', '==', firebase.auth().currentUser.uid], ['itemRef', '==', this.$route.params.id]]
        await this.$store.dispatch('PhotoModule/openDBChannel', {where})
        this.photosLoaded = true
      }
    },
    beforeDestroy() {
      this.$store.dispatch('PhotoModule/closeDBChannel');
    },
    computed: {
      tags: function() {
        var tags = [
          {name: 'sell', enabled: false, color: 'blue'},
          {name: 'keep', enabled: false, color: 'green'},
          {name: 'donate', enabled: false, color: 'red'}
        ];

        if (this.item.tags) {
          for (var i = 0; i < tags.length; i++) {
            if (this.item.tags.includes(tags[i].name)) {
              tags[i].enabled = true;
            }
          }
        }

        return tags;
      },
      item: function () {
        return this.$store.getters['ItemModule/getById'](this.$route.params.id)
      },
      photos: function() {
        var photos = this.$store.getters['PhotoModule/get'].filter(photo => photo.itemRef == this.item.id && !photo.archived);
        return photos;
      }
      // ...mapGetters({
      //   photos: 'PhotoModule/get'
      // })
    },
    methods: {
      setAltImg: async function(photo) {
        photo.processed = false
        const storageRef = await firebase.storage().ref(`${photo.id}.jpg`)
        const downloadUrl = await storageRef.getDownloadURL()
        photo.data = downloadUrl
        this.$store.dispatch('PhotoModule/save', photo)
        photo.processed = true
      },
      scan: function(photo) {
        photo.scanning = true
        const scanPhoto = firebase.functions().httpsCallable('scanPhoto');
        scanPhoto({ text: photo.data })
          .then((result) => {
            if (result.data.objects) {
              let objects = []
              for (var i = 0; i < result.data.objects.length; i++) {
                let curObject = result.data.objects[i]
                // if (curObject.score > 0.7) {
                objects.push({name: curObject.name, score: curObject.score})
                // }
              }

              let text = []
              for (var j = 0; j < result.data.text.length; j++) {
                //text.push(result.data.text[i].description)
              }

              photo.objects = (objects)
              photo.logos = ""
              photo.text = (text)
              this.$store.dispatch('PhotoModule/addMetadata', {id: photo.id, objects: photo.objects, logos: photo.logos, text: photo.text})
            }
          });                    
      },
      save: function() {
        this.isEditing = false
        this.$store.dispatch('ItemModule/save', this.item)
      },
      cancel: function() {
        this.isEditing = false
      },
      edit: function() {
        this.isEditing = true
      },
      setFeaturedImage: async function (photo) {
        this.item.data = photo.data
        this.$store.dispatch('ItemModule/setUrl', this.item)
      },
      archivePhoto: async function (photo) {
        await this.doConfirm("Archive Photo", `Are you sure you want to archive this photo?`, async function(store) {
          await store.dispatch('PhotoModule/archive', photo)
          window.jQuery('.ui.modal').modal('hide')
        })
      },
      setTag: function(tag) {
        if (!this.item.tags) {
          this.item.tags = []
        }

        var index = this.item.tags.indexOf(tag.name);
        if (index > -1) {
          this.item.tags.splice(index, 1);
        } else {
          this.item.tags.push(tag.name);
        }

        this.$store.dispatch('ItemModule/save', this.item)
      },
      doModalAction: async function() {
        this.modalAction(this.$store)
      },
      doConfirm: async function(header, message, action) {
        this.modalHeader = header
        this.modalMessage = message
        this.modalAction = action
        window.jQuery('.ui.modal').modal('show')
      }
    }
}
</script>

<style scoped>
#take-photo {text-align: center; margin:0 auto; transform: translateY(-75px);}
#take-photo button {margin-right: 15px;}
.card .image img:before {
    content: ' ';
    display: block;
    position: absolute;
    height: 100%;
    width: 100%;
    background-image: url(https://via.placeholder.com/260x150);
  }
</style>